// Sim / Em parte / Não / Sem resposta as native radios styled as pills (keyboard arrows work), shared by the
// consultant's scenario page and the participant's category page (BLD-28).
import { Lock } from "lucide-react";
import { cx } from "../ui.tsx";
import { ANSWERS, type Answer } from "../../../shared/maturity/responses.ts";
import { ANSWER_LABEL, NO_ANSWER_LABEL } from "../../../shared/maturity/scoring.ts";

const OPTIONS: { value: Answer | null; label: string }[] = [...ANSWERS.map((v) => ({ value: v, label: ANSWER_LABEL[v] })), { value: null, label: NO_ANSWER_LABEL }];

export function AnswerOptions({ name, value, frozen, onChange, lockedLabel = "Encerrado" }: {
  name: string; value: Answer | null; frozen: boolean; onChange: (v: Answer | null) => void; lockedLabel?: string;
}) {
  return (
    <div className="mt-3 grid grid-cols-2 gap-2 sm:flex sm:flex-wrap">
      {OPTIONS.map((o) => {
        const checked = value === o.value;
        return (
          <label key={o.label} className={cx(
            "relative inline-flex min-h-10 cursor-pointer items-center justify-center rounded-ctl border px-4 text-sm font-semibold transition-[background-color,border-color,box-shadow] duration-[var(--duration-base)]",
            "has-[:focus-visible]:ring-3 has-[:focus-visible]:ring-accent/40",
            checked ? (o.value ? "border-primary bg-primary text-white shadow-e1" : "border-ink-3 bg-paper text-ink") : "border-line-strong bg-surface text-ink hover:bg-paper",
            frozen && "cursor-default opacity-90",
          )}>
            <input type="radio" className="sr-only" name={name} value={o.value ?? ""} checked={checked} disabled={frozen && !checked}
              readOnly={frozen} onChange={() => !frozen && onChange(o.value)} />
            {o.label}
          </label>
        );
      })}
      {frozen && <span className="inline-flex items-center gap-1 text-xs text-ink-3"><Lock className="size-3.5" aria-hidden />{lockedLabel}</span>}
    </div>
  );
}
